function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useState } from "react";
function getContrastColor(hexColor) {
  var _formattedColor$match, _formattedColor$match2;
  if (!hexColor) {
    return "#000000"; // Default contrasting color if input is undefined
  }
  var formattedColor = hexColor;
  if (formattedColor.length === 4) {
    // Convert 3-digit hex to 6-digit hex
    formattedColor = "#".concat(formattedColor[1]).concat(formattedColor[1]).concat(formattedColor[2]).concat(formattedColor[2]).concat(formattedColor[3]).concat(formattedColor[3]);
  }
  var parsedColor = (_formattedColor$match = (_formattedColor$match2 = formattedColor.match(/[A-Fa-f0-9]{2}/g)) === null || _formattedColor$match2 === void 0 ? void 0 : _formattedColor$match2.map(function (_char) {
    return parseInt(_char, 16);
  })) !== null && _formattedColor$match !== void 0 ? _formattedColor$match : [];
  var _parsedColor = _slicedToArray(parsedColor, 3),
    r = _parsedColor[0],
    g = _parsedColor[1],
    b = _parsedColor[2];
  var luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5 ? "#000000" : "#FFFFFF";
}
function useContrastColor(initialColor) {
  var _useState = useState(getContrastColor(initialColor)),
    _useState2 = _slicedToArray(_useState, 2),
    contrastColor = _useState2[0],
    setContrastColor = _useState2[1];
  useEffect(function () {
    setContrastColor(getContrastColor(initialColor));
  }, [initialColor]);
  return contrastColor;
}
export default useContrastColor;